(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.info', [
    'mgpCorregedoriaApp.core'
  ]);

})();